import React from 'react';
import { Container,Card } from "react-bootstrap";
import { Layout, Row, Col, Tabs } from 'antd';
import CodeBlockComponent from '../components/dashboard/CodeBlockComponent';
import * as constant from './../../constants/constants'

const { Header, Content } = Layout;
const { TabPane } = Tabs;

const htmlCode = constant.cr_codeIframe;
const htmlCode2 = constant.cr_codeIframeHtml;
const codeHTML = constant.cr_codeHTML;
const codeJS = constant.cr_codeJS;
const codeCSS = constant.cr_codeCSS;

export default function ContenidoRecomendado(){
  return (
    <Container className="content">
      <Content >
         <Row>
          <span className='h3 mt-1 text-black'>Contenido recomendado</span>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={12}>
            <Card className="code-card">
              <Card.Body>
                <span className='fs-5'>Código embebido</span>
                <CodeBlockComponent code={htmlCode} language="html" />
                <div style={{border:"1px solid #eee"}}>
                  <div dangerouslySetInnerHTML={{ __html: htmlCode2 }} />
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={24} xl={12} className=''>
            <Card className="code-card">
              <Card.Body>
                <span className='fs-5'>Código HTML</span>
                <Tabs defaultActiveKey="1" >
                  <TabPane tab="HTML" key="1"  >
                    <CodeBlockComponent code={codeHTML} language="html" />
                  </TabPane>
                  <TabPane tab="JavaScript" key="2">
                    <CodeBlockComponent code={codeJS} language="javascript" />
                  </TabPane>
                  <TabPane tab="CSS" key="3">
                    <CodeBlockComponent code={codeCSS} language="css" />
                  </TabPane>
                </Tabs>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Content>
    </Container>
  );
};